import { Text, VStack, CSSObject } from '@chakra-ui/react'

interface Props {
  title?: React.ReactNode
  children: React.ReactNode
  sx?: CSSObject
}

function Widget({ title, children, sx }: Props): React.ReactElement {
  return (
    <VStack
      spacing="3"
      sx={{
        alignSelf: 'stretch',
        alignItems: 'stretch',
        color: 'gray.900',
        fontSize: {
          base: 'xl',
          sm: '2xl',
        },
        bg: 'gray.50',
        borderRadius: '2xl',
        px: {
          base: 6,
          sm: 8,
        },
        py: 6,
        ...sx,
      }}
    >
      {title && (
        <Text as="h3" sx={{ fontWeight: 'medium', fontSize: '2xl' }}>
          {title}
        </Text>
      )}
      {children}
    </VStack>
  )
}

export default Widget
